export default __webpack_public_path__ + "static/media/alexa8.94adf464.jpg";